var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8;
import { __awaiter, __decorate, __metadata } from "tslib";
import { Mutation, Action, VuexModule, Module } from 'vuex-module-decorators';
import axios from 'axios';
import ApiService from '@/core/services/ApiService';
import { Actions, Mutations } from '@/store/enums/finance/AssetProfillingClassEnums';
let AssetProfillingClassModule = class AssetProfillingClassModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.wasFirstLoad = true;
        this.loading = false;
        this.assetProfillingClassList = [];
        this.assetProfillingClassCode = [];
        this.assetProfillingClassDesc = [];
        this.selectedCategoryCode = [];
        this.selectedCategoryDesc = [];
        this.isActive = true;
        this.useFilter = true;
        this.assetProfillingClassPaging = [];
        this.loadPage = false;
        this.page = 1;
        this.size = 10;
        this.pageFilter = 1;
        this.wasLoadQuickFilter = true;
        this.desc = '';
        this.status = '';
        this.statusMessage = '';
        this.searchBy = '';
    }
    get getAssetProfillingClassWasFirstLoad() {
        return this.wasFirstLoad;
    }
    get getAssetProfillingClassLoading() {
        return this.loading;
    }
    get getAssetProfillingClassDataList() {
        return this.assetProfillingClassList;
    }
    get getAssetProfillingClassListCode() {
        return this.assetProfillingClassCode;
    }
    get getAssetProfillingClassListDesc() {
        return this.assetProfillingClassDesc;
    }
    get getAssetProfillingClassSelectedCode() {
        return this.selectedCategoryCode;
    }
    get getAssetProfillingClassSelectedDesc() {
        return this.selectedCategoryDesc;
    }
    get getAssetProfillingClassActive() {
        return this.isActive;
    }
    get getAssetProfillingClassPaging() {
        return this.assetProfillingClassPaging;
    }
    get getAssetProfillingClassSize() {
        return this.size;
    }
    get getAssetProfillingClassStatus() {
        const status = {
            status: this.status,
            statusMessage: this.statusMessage
        };
        return status;
    }
    get getAssetProfillingClassUseFilter() {
        return this.useFilter;
    }
    get getAssetProfillingClassWasLoadQuickFilter() {
        return this.wasLoadQuickFilter;
    }
    get getAssetProfillingClassDesc() {
        return this.desc;
    }
    get getAssetProfillingClassSearchBy() {
        return this.searchBy;
    }
    [_a = Mutations.SET_ASSET_PROFILLING_CLASS_WAS_FIRST_LOAD](payload) {
        this.wasFirstLoad = payload;
    }
    [_b = Mutations.SET_ASSET_PROFILLING_CLASS_LOADING](payload) {
        this.loading = payload;
    }
    [_c = Mutations.SET_ASSET_PROFILLING_CLASS_HANDLE_PAGE](payload) {
        this.page = payload;
    }
    [_d = Mutations.SET_ASSET_PROFILLING_CLASS_LIST](payload) {
        this.assetProfillingClassList = payload;
    }
    [_e = Mutations.SET_ASSET_PROFILLING_CLASS_LIST_CODE](payload) {
        this.assetProfillingClassCode = payload;
    }
    [_f = Mutations.SET_ASSET_PROFILLING_CLASS_LIST_DESC](payload) {
        this.assetProfillingClassDesc = payload;
    }
    [_g = Mutations.SET_SELECTED_ASSET_PROFILLING_CLASS_CODE](payload) {
        this.selectedCategoryCode = payload;
    }
    [_h = Mutations.SET_SELECTED_ASSET_PROFILLING_CLASS_DESC](payload) {
        this.selectedCategoryDesc = payload;
    }
    [_j = Mutations.SET_SELECTED_ASSET_PROFILLING_CLASS_ACTIVE](payload) {
        this.isActive = payload;
    }
    [_k = Mutations.SET_ASSET_PROFILLING_CLASS_PAGE](payload) {
        this.assetProfillingClassPaging = payload;
    }
    [_l = Mutations.SET_ASSET_PROFILLING_CLASS_LOAD_PAGE]() {
        this.loadPage = true;
    }
    [_m = Mutations.SET_ASSET_PROFILLING_CLASS_STATUS](payload) {
        this.status = payload.status;
        this.statusMessage = payload.message;
    }
    [_o = Mutations.SET_ASSET_PROFILLING_CLASS_SIZE](payload) {
        this.size = payload;
    }
    [_p = Mutations.SET_ASSET_PROFILLING_CLASS_USE_FILTER](payload) {
        this.useFilter = payload;
    }
    [_q = Mutations.SET_ASSET_PROFILLING_CLASS_PAGE_FILTER](payload) {
        this.pageFilter = payload;
    }
    [_r = Mutations.SET_ASSET_PROFILLING_CLASS_WAS_LOAD_QUICK_FILTER](payload) {
        this.wasLoadQuickFilter = payload;
    }
    [_s = Mutations.SET_ASSET_PROFILLING_CLASS_SEARCH_BY](payload) {
        this.searchBy = payload;
    }
    [_t = Mutations.SET_ASSET_PROFILLING_CLASS_SEARCH_KEY](payload) {
        this.desc = payload;
    }
    [_u = Actions.GET_ASSET_PROFILLING_CLASS_LIST]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_ASSET_PROFILLING_CLASS_LOADING, true);
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/assetprofillingclass`;
            const params = {
                ver: 'v1',
                Page: this.page.toString(),
                Size: this.size.toString(),
                Desc: this.desc
            };
            return new Promise((resolve, reject) => {
                ApiService.get(url, '', new URLSearchParams(params).toString())
                    .then((res) => {
                    if (res.status === 200) {
                        this.context.commit(Mutations.SET_ASSET_PROFILLING_CLASS_LIST, res.data.result.content.data);
                        this.context.commit(Mutations.SET_ASSET_PROFILLING_CLASS_LOAD_PAGE, true);
                        this.context.commit(Mutations.SET_ASSET_PROFILLING_CLASS_PAGE, res.data.result.content.paging);
                        this.context.commit(Mutations.SET_ASSET_PROFILLING_CLASS_LOADING, false);
                        resolve(true);
                    }
                    else {
                        this.context.commit(Mutations.SET_ASSET_PROFILLING_CLASS_LOADING, false);
                        reject(false);
                    }
                })
                    .catch((err) => {
                    this.context.commit(Mutations.SET_ASSET_PROFILLING_CLASS_LOADING, false);
                    reject(false);
                });
            });
        });
    }
    [_v = Actions.GET_ASSET_PROFILLING_CLASS_LIST_CODE_DESC]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_ASSET_PROFILLING_CLASS_WAS_LOAD_QUICK_FILTER, false);
            const params = {
                ver: 'v1'
            };
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/assetprofillingclass/filter?` +
                new URLSearchParams(params).toString();
            const paramsData = {
                Page: this.pageFilter.toString(),
                Size: '10',
                Desc: this.desc,
                SearchBy: this.searchBy,
                assetProfillingClassCode: [],
                assetProfillingClassDesc: [],
                isActive: this.isActive
            };
            const dataCode = [...this.assetProfillingClassCode];
            const dataDesc = [...this.assetProfillingClassDesc];
            return new Promise((resolve, reject) => {
                ApiService.post(url, paramsData)
                    .then((res) => {
                    if (res.status === 200) {
                        if (res.data.result.content !== null) {
                            if (res.data.result.content.paging.totalPages === this.pageFilter) {
                                this.context.commit(Mutations.SET_ASSET_PROFILLING_CLASS_WAS_LOAD_QUICK_FILTER, false);
                            }
                            else {
                                this.context.commit(Mutations.SET_ASSET_PROFILLING_CLASS_WAS_LOAD_QUICK_FILTER, true);
                            }
                            res.data.result.content.data.map((data) => {
                                dataCode.push({
                                    value: data.assetProfillingClassCode,
                                    label: data.assetProfillingClassCode
                                });
                                dataDesc.push({
                                    value: data.assetProfillingClassDesc,
                                    label: data.assetProfillingClassDesc
                                });
                            });
                        }
                        else {
                            this.context.commit(Mutations.SET_ASSET_PROFILLING_CLASS_WAS_LOAD_QUICK_FILTER, false);
                        }
                        this.context.commit(Mutations.SET_ASSET_PROFILLING_CLASS_LIST_CODE, dataCode);
                        this.context.commit(Mutations.SET_ASSET_PROFILLING_CLASS_LIST_DESC, dataDesc);
                        resolve(true);
                    }
                    else {
                        this.context.commit(Mutations.SET_ASSET_PROFILLING_CLASS_WAS_LOAD_QUICK_FILTER, true);
                        reject(false);
                    }
                })
                    .catch((err) => {
                    this.context.commit(Mutations.SET_ASSET_PROFILLING_CLASS_WAS_LOAD_QUICK_FILTER, true);
                    reject(false);
                });
            });
        });
    }
    [_w = Actions.CREATE_ASSET_PROFILLING_CLASS_LIST](data) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/assetprofillingclass?ver=v1`;
            return new Promise((resolve, reject) => {
                ApiService.post(url, data)
                    .then((res) => {
                    if (res) {
                        this.context.commit(Mutations.SET_ASSET_PROFILLING_CLASS_LIST_CODE, []);
                        this.context.commit(Mutations.SET_ASSET_PROFILLING_CLASS_LIST_DESC, []);
                        this.context.commit(Mutations.SET_ASSET_PROFILLING_CLASS_PAGE_FILTER, 1);
                        this.context.dispatch(Actions.GET_ASSET_PROFILLING_CLASS_LIST_CODE_DESC);
                        this.context.commit(Mutations.SET_ASSET_PROFILLING_CLASS_STATUS, {
                            status: res.data.statusCode,
                            message: res.data.result.message
                        });
                        this.context.dispatch(Actions.GET_ASSET_PROFILLING_CLASS_DATA);
                        resolve(true);
                    }
                    else {
                        reject(false);
                    }
                    return res;
                })
                    .catch(() => {
                    reject(false);
                });
            });
        });
    }
    [_x = Actions.UPDATE_ASSET_PROFILLING_CLASS_LIST](data) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/assetprofillingclass?ver=v1`;
            return new Promise((resolve, reject) => {
                ApiService.post(url, data)
                    .then((res) => {
                    if (res) {
                        this.context.commit(Mutations.SET_ASSET_PROFILLING_CLASS_LIST_CODE, []);
                        this.context.commit(Mutations.SET_ASSET_PROFILLING_CLASS_LIST_DESC, []);
                        this.context.commit(Mutations.SET_ASSET_PROFILLING_CLASS_PAGE_FILTER, 1);
                        this.context.dispatch(Actions.GET_ASSET_PROFILLING_CLASS_LIST_CODE_DESC);
                        this.context.commit(Mutations.SET_ASSET_PROFILLING_CLASS_STATUS, {
                            status: res.data.statusCode,
                            message: res.data.result.message
                        });
                        this.context.dispatch(Actions.GET_ASSET_PROFILLING_CLASS_DATA);
                        resolve(true);
                    }
                    else {
                        reject(false);
                    }
                    return res;
                })
                    .catch(() => {
                    reject(false);
                });
            });
        });
    }
    [_y = Actions.GET_ASSET_PROFILLING_CLASS_LIST_FILTER](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_SELECTED_ASSET_PROFILLING_CLASS_CODE, data.assetProfillingClassCode);
            this.context.commit(Mutations.SET_SELECTED_ASSET_PROFILLING_CLASS_DESC, data.assetProfillingClassDesc);
            this.context.commit(Mutations.SET_SELECTED_ASSET_PROFILLING_CLASS_ACTIVE, data.isActive);
            const params = {
                ver: 'v1'
            };
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/assetprofillingclass/filter?` +
                new URLSearchParams(params).toString();
            const paramsData = {
                Page: this.page.toString(),
                Size: this.size.toString(),
                Desc: '',
                SearchBy: '',
                assetProfillingClassCode: data.assetProfillingClassCode,
                assetProfillingClassDesc: data.assetProfillingClassDesc,
                isActive: data.isActive
            };
            return new Promise((resolve, reject) => {
                ApiService.post(url, paramsData)
                    .then((res) => {
                    var _9, _10, _11;
                    if (res.status === 200) {
                        this.context.commit(Mutations.SET_ASSET_PROFILLING_CLASS_LIST, ((_9 = res.data.result.content) === null || _9 === void 0 ? void 0 : _9.data) || []);
                        if (!this.loadPage) {
                            this.context.commit(Mutations.SET_ASSET_PROFILLING_CLASS_LOAD_PAGE, true);
                            this.context.commit(Mutations.SET_ASSET_PROFILLING_CLASS_PAGE, ((_10 = res.data.result.content) === null || _10 === void 0 ? void 0 : _10.paging) || {
                                currentPage: 0,
                                totalPages: 0,
                                totalElements: 0,
                                errorRows: 0,
                                readyToUpload: 0
                            });
                        }
                        this.context.commit(Mutations.SET_ASSET_PROFILLING_CLASS_PAGE, ((_11 = res.data.result.content) === null || _11 === void 0 ? void 0 : _11.paging) || {
                            currentPage: 0,
                            totalPages: 0,
                            totalElements: 0,
                            errorRows: 0,
                            readyToUpload: 0
                        });
                        resolve(true);
                    }
                    else {
                        reject(false);
                    }
                })
                    .catch((err) => {
                    reject(false);
                });
            });
        });
    }
    [_z = Actions.DOWNLOAD_ASSET_PROFILLING_CLASS]() {
        return __awaiter(this, void 0, void 0, function* () {
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/fincapex/api/master/assetprofillingclass/download?ver=v1`;
            axios({
                url: apiUrl,
                method: 'POST',
                responseType: 'blob',
                data: {
                    assetProfillingClassCode: this.selectedCategoryCode,
                    assetProfillingClassDesc: this.selectedCategoryDesc,
                    isActive: this.isActive
                }
            }).then((response) => {
                // eslint-disable-next-line comma-spacing
                const fileName = response.headers['content-disposition']
                    .split('; ')[1]
                    .split('=')[1]
                    .replaceAll('/', '-')
                    .replaceAll('"', '');
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
            });
        });
    }
    [_0 = Actions.UPDATE_ASSET_PROFILLING_CLASS_PAGE_FILTER]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_ASSET_PROFILLING_CLASS_PAGE_FILTER, this.pageFilter + 1);
        });
    }
    [_1 = Actions.GET_ASSET_PROFILLING_CLASS_DATA]() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.useFilter) {
                this.context.dispatch(Actions.GET_ASSET_PROFILLING_CLASS_LIST);
            }
            else {
                this.context.dispatch(Actions.GET_ASSET_PROFILLING_CLASS_LIST_FILTER, {
                    assetProfillingClassCode: this.selectedCategoryCode,
                    assetProfillingClassDesc: this.selectedCategoryDesc,
                    isActive: this.isActive
                });
            }
        });
    }
    [_2 = Actions.UPDATE_SELECTED_ASSET_PROFILLING_CLASS_CODE](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_SELECTED_ASSET_PROFILLING_CLASS_CODE, data);
            this.context.commit(Mutations.SET_ASSET_PROFILLING_CLASS_HANDLE_PAGE, 1);
            this.context.dispatch(Actions.GET_ASSET_PROFILLING_CLASS_DATA);
        });
    }
    [_3 = Actions.UPDATE_SELECTED_ASSET_PROFILLING_CLASS_DESC](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_SELECTED_ASSET_PROFILLING_CLASS_DESC, data);
            this.context.commit(Mutations.SET_ASSET_PROFILLING_CLASS_HANDLE_PAGE, 1);
            this.context.dispatch(Actions.GET_ASSET_PROFILLING_CLASS_DATA);
        });
    }
    [_4 = Actions.UPDATE_SELECTED_ASSET_PROFILLING_CLASS_ACTIVE](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_SELECTED_ASSET_PROFILLING_CLASS_ACTIVE, data);
            this.context.commit(Mutations.SET_SELECTED_ASSET_PROFILLING_CLASS_CODE, []);
            this.context.commit(Mutations.SET_SELECTED_ASSET_PROFILLING_CLASS_DESC, []);
            this.context.commit(Mutations.SET_ASSET_PROFILLING_CLASS_HANDLE_PAGE, 1);
            this.context.commit(Mutations.SET_ASSET_PROFILLING_CLASS_PAGE_FILTER, 1);
            this.context.dispatch(Actions.GET_ASSET_PROFILLING_CLASS_DATA);
            this.context.dispatch(Actions.GET_ASSET_PROFILLING_CLASS_LIST_CODE_DESC);
        });
    }
    [_5 = Actions.UPDATE_ASSET_PROFILLING_CLASS_SIZE](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_ASSET_PROFILLING_CLASS_SIZE, data);
            this.context.commit(Mutations.SET_ASSET_PROFILLING_CLASS_HANDLE_PAGE, 1);
            this.context.dispatch(Actions.GET_ASSET_PROFILLING_CLASS_DATA);
        });
    }
    [_6 = Actions.RESET_ASSET_PROFILLING_CLASS_FILTER]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_SELECTED_ASSET_PROFILLING_CLASS_CODE, []);
            this.context.commit(Mutations.SET_SELECTED_ASSET_PROFILLING_CLASS_DESC, []);
            this.context.commit(Mutations.SET_SELECTED_ASSET_PROFILLING_CLASS_ACTIVE, true);
            this.context.commit(Mutations.SET_ASSET_PROFILLING_CLASS_HANDLE_PAGE, 1);
            this.context.commit(Mutations.SET_ASSET_PROFILLING_CLASS_PAGE_FILTER, 1);
            this.context.dispatch(Actions.GET_ASSET_PROFILLING_CLASS_DATA);
            this.context.dispatch(Actions.GET_ASSET_PROFILLING_CLASS_LIST_CODE_DESC);
        });
    }
    [_7 = Actions.UPDATE_SEARCH_ASSET_PROFILLING_CLASS_DESC](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_ASSET_PROFILLING_CLASS_SEARCH_BY, 'AssetProfillingClassDesc');
            this.context.commit(Mutations.SET_ASSET_PROFILLING_CLASS_SEARCH_KEY, data);
            this.context.commit(Mutations.SET_ASSET_PROFILLING_CLASS_HANDLE_PAGE, 1);
            this.context.commit(Mutations.SET_ASSET_PROFILLING_CLASS_LIST_DESC, []);
            this.context.dispatch(Actions.GET_ASSET_PROFILLING_CLASS_LIST_CODE_DESC);
        });
    }
    [_8 = Actions.UPDATE_SEARCH_ASSET_PROFILLING_CLASS_CODE](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_ASSET_PROFILLING_CLASS_SEARCH_BY, 'AssetProfillingClassCode');
            this.context.commit(Mutations.SET_ASSET_PROFILLING_CLASS_SEARCH_KEY, data);
            this.context.commit(Mutations.SET_ASSET_PROFILLING_CLASS_HANDLE_PAGE, 1);
            this.context.commit(Mutations.SET_ASSET_PROFILLING_CLASS_LIST_CODE, []);
            this.context.dispatch(Actions.GET_ASSET_PROFILLING_CLASS_LIST_CODE_DESC);
        });
    }
};
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AssetProfillingClassModule.prototype, _a, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AssetProfillingClassModule.prototype, _b, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AssetProfillingClassModule.prototype, _c, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AssetProfillingClassModule.prototype, _d, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AssetProfillingClassModule.prototype, _e, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AssetProfillingClassModule.prototype, _f, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AssetProfillingClassModule.prototype, _g, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AssetProfillingClassModule.prototype, _h, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AssetProfillingClassModule.prototype, _j, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AssetProfillingClassModule.prototype, _k, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AssetProfillingClassModule.prototype, _l, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AssetProfillingClassModule.prototype, _m, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AssetProfillingClassModule.prototype, _o, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AssetProfillingClassModule.prototype, _p, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AssetProfillingClassModule.prototype, _q, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AssetProfillingClassModule.prototype, _r, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AssetProfillingClassModule.prototype, _s, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AssetProfillingClassModule.prototype, _t, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], AssetProfillingClassModule.prototype, _u, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], AssetProfillingClassModule.prototype, _v, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], AssetProfillingClassModule.prototype, _w, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], AssetProfillingClassModule.prototype, _x, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], AssetProfillingClassModule.prototype, _y, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], AssetProfillingClassModule.prototype, _z, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], AssetProfillingClassModule.prototype, _0, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], AssetProfillingClassModule.prototype, _1, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], AssetProfillingClassModule.prototype, _2, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], AssetProfillingClassModule.prototype, _3, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], AssetProfillingClassModule.prototype, _4, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], AssetProfillingClassModule.prototype, _5, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], AssetProfillingClassModule.prototype, _6, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], AssetProfillingClassModule.prototype, _7, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], AssetProfillingClassModule.prototype, _8, null);
AssetProfillingClassModule = __decorate([
    Module
], AssetProfillingClassModule);
export default AssetProfillingClassModule;
